<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :vislble-alert="true"
    />

    <!-- 구분 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 구분</h5>
      <radio-group
        v-model="form.구분"
        :readonly="board.readonly"
        flex
        :items="['안전관리자', '보건관리자', '산업보건의']" />
    </div>



    <!-- 선임대상 정보 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 선임대상 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">이름</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.이름 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.이름" :max="20"/>
        </div>
        <div>
          <div class="form-title">직급</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.직급 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.직급" :max="20"/>
        </div>
        <div>
          <div class="form-title">최초 선임일</div>
          <p v-if="isPrint" class="print-input">{{ form.선임일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.선임일" />
        </div>
        <div>
          <div class="form-title">최근 교육이수일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.최근교육이수일 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.최근교육이수일" :max="20"/>
        </div>
        <div>
          <div class="form-title">교육이수증</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.교육이수증 }}</p>
          <file-uploader v-else v-model="form.교육이수증"/>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import TableCustom from "@/components/TableCustom.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  components: {
    RadioGroup,
    FileUploader,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
    TableCustom,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    SignField,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        구분: "",
        이름: "",
        직급: "",
        선임일: "",
        최근교육이수일: "",
        교육이수증: {},
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  word-break: keep-all;
}
</style>

